import { render, staticRenderFns } from "./Detalhe_EmpresasUni.vue?vue&type=template&id=071c786e&scoped=true&"
import script from "./Detalhe_EmpresasUni.vue?vue&type=script&lang=js&"
export * from "./Detalhe_EmpresasUni.vue?vue&type=script&lang=js&"
import style0 from "./Detalhe_EmpresasUni.vue?vue&type=style&index=0&id=071c786e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "071c786e",
  null
  
)

export default component.exports